import address from './address.json';

export const enUs = {
  translation: {
    address,
  },
};
